export const affirmations = [
  "Welcome, Take a breath. You're exactly where you need to be.",
  "Let's begin gently No pressure, no perfection, just presence.",
  "Wouldn't it be nice to feel just a little bit lighter right now?",
  "Maybe it's possible that things could feel easier than I've been making them",
  "I'm open to the idea that I deserve to feel good",
  "On your next tap Allow the sound to bring you deeper into this moment",
  "I'm starting to remember my own strength",
  "I trust that I'm moving in the right direction",
  "I am capable of creating positive changes in my life",
  "I am worthy of love, peace, and happiness",
  "This is just the beginning. Experience the full journey in the app"
];

export const initialAffirmation = "Welcome, Take a breath. You're exactly where you need to be.";
